var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardInactive = function SvgCardInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.838 8.138H4.34c-.908 0-1.644.736-1.644 1.644v11.771c0 .909.736 1.645 1.644 1.645h21.498c.908 0 1.644-.736 1.644-1.645V9.782c0-.908-.736-1.644-1.644-1.644Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.482 11.902H2.696v3.765h24.786v-3.765Z",
    fill: "#999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.66 5H2.162C1.254 5 .518 5.736.518 6.644v11.772c0 .908.736 1.644 1.644 1.644H23.66c.908 0 1.644-.736 1.644-1.644V6.644c0-.908-.736-1.644-1.644-1.644Z",
    fill: "#D8D8D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.925 7.692H3.913a.376.376 0 0 0-.376.376v1.965c0 .207.168.376.376.376h3.012a.376.376 0 0 0 .376-.377V8.069a.377.377 0 0 0-.376-.376ZM17.454 14.933a2.402 2.402 0 0 1 1.218-2.09c-.37-.212-.791-.32-1.218-.313a2.435 2.435 0 1 0 1.218 4.524 2.417 2.417 0 0 1-1.218-2.12Z",
    fill: "#999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.858 12.53c-.43 0-.85.117-1.218.339a2.409 2.409 0 0 1 0 4.185 2.426 2.426 0 0 0 3.572-1.465 2.43 2.43 0 0 0-2.354-3.06Z",
    fill: "#999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.858 14.933a2.416 2.416 0 0 0-1.218-2.09 2.409 2.409 0 0 0 0 4.186 2.429 2.429 0 0 0 1.218-2.096Z",
    fill: "#E5E5E5"
  })));
};
export default SvgCardInactive;